import React from 'react';
import './Input.css';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  sizeVariant?: 'default' | 'large';
}

const Input: React.FC<InputProps> = ({ 
  label, 
  error, 
  id, 
  className = '',
  sizeVariant = 'default',
  ...props 
}) => {
  const inputId = id || `input-${label.toLowerCase().replace(/\s+/g, '-')}`;
  
  return (
    <div className={`form-control ${error ? 'has-error' : ''} ${className}`}>
      <label htmlFor={inputId} className={`form-label ${sizeVariant === 'large' ? 'form-label-large' : ''}`}>
        {label}
      </label>
      <input 
        id={inputId}
        className={`form-input ${sizeVariant === 'large' ? 'form-input-large' : ''}`}
        {...props}
      />
      {error && <div className="form-error">{error}</div>}
    </div>
  );
};

export default Input; 